import Fetch from '../Fetch';

export default {
  loginPwd: (params) => { //账号密码登录
    return Fetch.post(`/api/v1/login`, params);
  },
  logout: (success, error) => { //安全退出
    return Fetch.get(`/api/v1/logout`);
  },
  changePassword: (params, success, error) => { //修改密码
    return Fetch.post(`/api/v1/user_password`, params);
  },
}
